import { useState, type CSSProperties } from 'react'
import type { ResponsiveImageData } from '../data/images'
import type { Transformation } from '../data/transformations'
import { ResponsiveImage } from './ResponsiveImage'

type TransformationCompareProps = {
  item: Transformation
}

function TransformationPanel({
  image,
  alt,
  label,
  position,
}: {
  image?: ResponsiveImageData
  alt: string
  label: string
  position?: string
}) {
  return image ? (
    <ResponsiveImage image={image} alt={alt} sizes="(max-width: 700px) 100vw, 50vw" objectPosition={position} />
  ) : (
    <div className="transformation-placeholder" aria-hidden="true">
      <span>{label}</span>
      <small>Client image coming soon</small>
    </div>
  )
}

export function TransformationCompare({ item }: TransformationCompareProps) {
  const [reveal, setReveal] = useState(50)
  const comparisonStyle = { '--reveal': `${reveal}%` } as CSSProperties

  return (
    <article className="transformation-card">
      <div className="transformation-card__meta">
        <span>{item.number}</span>
        <p>{item.service}</p>
      </div>
      <div className="transformation-compare" style={comparisonStyle}>
        <figure className="transformation-compare__panel transformation-compare__before">
          <TransformationPanel
            image={item.beforeImage}
            alt={item.beforeAlt}
            label="Before"
            position={item.beforePosition}
          />
          <figcaption className="transformation-compare__label">Before</figcaption>
        </figure>
        <figure className="transformation-compare__panel transformation-compare__after">
          <TransformationPanel
            image={item.afterImage}
            alt={item.afterAlt}
            label="After"
            position={item.afterPosition}
          />
          <figcaption className="transformation-compare__label">After</figcaption>
        </figure>
        <span className="transformation-compare__line" aria-hidden="true"><i /></span>
        <input
          className="transformation-compare__range"
          type="range"
          min="0"
          max="100"
          value={reveal}
          onChange={(event) => setReveal(Number(event.target.value))}
          aria-label={`Reveal before and after for ${item.title}`}
        />
      </div>
      <div className="transformation-card__copy">
        <h3>{item.title}</h3>
        <p>{item.description}</p>
        <span>Drag to reveal</span>
      </div>
    </article>
  )
}
